<template>
	<div class="content">
		<el-page-header @back="$router.go(-1)" content="订单列表" />
		<div class="nullImg" v-if="total == 0 " >
			<div class="Bigbox">
				<img src="../../assets/img/null02.jpg" alt="">
			</div>
		</div>
		<div  v-else >
			<div v-for="(lis,index) in tableData" :key="index">
				<div class="cont_box" >
					<el-card class="bigBox">
						<div class="bigBox_title">
							<div class="title_left">
								<span>订单编号：{{lis.order_sn}}</span>
								<span>创建时间：{{lis.add_time}}</span>
							</div>
							<div class="title_center">
								<span class="order-time">收货人：{{lis.address_name ? lis.address_name :'暂无信息'}}</span>
								<span class="order-time">联系方式：{{lis.address_mobile ? lis.address_mobile :'暂无信息'}}</span>
								<span class="order-time">收货地址：{{lis.address_address ? lis.address_address :'暂无信息'}}</span>
							</div>
							<div class="title_right">
								<!-- <el-button type="info" size="small" disabled v-if="lis.pay_status==1">已付款</el-button>
								<el-button type="success" size="small" disabled v-if="lis.pay_status==2">已过期</el-button> -->
								<el-button size="small" type="danger" v-if="lis.pay_status==0" plain disabled>未支付</el-button>
								<el-button size="small" v-else-if="lis.pay_status==1" type="success" plain disabled>已支付</el-button>
								<el-button size="small" v-else-if="lis.pay_status==2" type="warning" plain disabled>已过期</el-button>
							
								<!-- <el-tag v-if="scope.row.pay_status==2" type="danger">超时</el-tag> -->
							</div>
						</div>
						<div class="lititleBox">
							<div class="lit_box">
								<div class="litcont_box">
									<div class="lit_left">
										<div class="box_box" v-for="goods in lis.goods" :key="goods.id">
											<div class="cont_img">
												<img :src='picUrl+goods.sku.photo' @click="open(`/product/${good.goods_id}`)"  :onerror="imgSrc">
											</div>
											<div class="cont_detail">
												<p>{{goods.sku.title}}</p>
												<p>型号：{{goods.sku.xinghao?goods.sku.xinghao:'暂无信息'}}</p>
												<p>品牌：{{goods.sku.money?goods.sku.money:'暂无信息'}}</p>
												<p>数量：{{goods.sku.goods_num}}</p>
											</div>
											<div class="cont_price">
												<p>修改前：{{goods.final_price}}元</p>
												<p>修改后：{{goods.revised_price}}元</p>
											</div>
											<div>
												<template>
													<el-link v-if="( !goods.edit_price_time ||goods.edit_price_time == null) && lis.pay_status==0" type="info" @click="changePrice(goods.id)">改价&nbsp;&nbsp;</el-link>
													<!-- <el-link  type="info" @click="changePrice(goods.id)">改价</el-link> -->
												</template>
											</div>
											<div class="message" v-if="goods.member_message">
												<span class="liuy">用户留言:</span> {{goods.member_message}}
											</div>
										</div>
				
									</div>
									<div class="lit_right">
										<div class="lit_store">
											<p>该店铺</p>
											<p>产品总价：{{lis.totle_amount}}</p>
											<p>省(优惠)：{{lis.sheng}}元</p>
										</div>
										<div class="lit_logistics">
											<template v-model="lis.order_express_code" class="wlbtn" v-if="lis.order_express_code == null && lis.pay_status==1">
												<el-button size="small" @click="toDeliver(lis.id)">去发货</el-button>
											</template>
											<template v-model="lis.order_express_code" class="wln" v-else>
												物流信息
												<p v-model="lis.order_express_name">快递公司：{{lis.order_express_name?lis.order_express_name:'暂无信息'}}</p>
												<p v-model="lis.order_express_code">快递单号：{{lis.order_express_code?lis.order_express_code:'暂无信息'}}</p>
												<p class="bz" v-model="lis.order_express_content">快递备注：{{lis.order_express_content?lis.order_express_content:'暂无信息'}}</p>
											</template>
										</div>
										<div class="lit_detail">
											<template  class="wlbtn" v-if="lis.order_express_code != null && lis.pay_status==1 && lis.order_express_shou_time == null">
												<el-button size="small" type="danger"  plain disabled>待收货</el-button>
											</template>
											
											<template class="wlbtn"  v-else-if="lis.order_express_code != null && lis.pay_status==1 && lis.order_express_shou_time != null">
												<el-button size="small" type="success"  plain disabled>已收货</el-button>
											</template>
											<div style="margin-top: 10px;">
												<!-- 有错 -->
												<el-button size="small" @click="open(rootUrl+'Myseller-order-orderDetail?user_id='+user_id+'&id='+`${lis.id}`)">详情
												</el-button>
											</div>
											<!-- <div style="margin-top: 10px;"> -->
												<!-- <el-button size="small" class="fpnews" @click="fpnews(lis.id)">发票信息</el-button> -->
											<!-- </div> -->
				
										</div>
									</div>
								</div>
							</div>
							
						</div>
					</el-card>
				</div>
				<!-- 发货弹框 -->
				<div class="logisticsBox">
					<div class="logistics">
						<span class="logtit">请填写发货信息</span>
						<el-form ref="form" :model="form" label-width="80px" :rules="rules">
							<div class="avatar" express_id="0">
								<el-form-item label="物流公司" style="margin-left: -10px;">
									<el-select v-model="form.getExpressList" @change="changew" filterable placeholder="可选择/输入">
										<el-option v-for="i in getExpressList" :key="i.id" :label="i.name" :value="i.id">
										</el-option>
									</el-select>
								</el-form-item>
								<div style="padding: 5px 5px;color: #9e9e9e;">如物流公司不存在，请在备注信息中注明所发物流信息</div>
							</div>
				
							<el-form-item label="快递单号" style="margin-left: -10px;">
								<el-input name="logcode" v-model="form.code" placeholder="请输入快递单号"></el-input>
							</el-form-item>
							<el-form-item label="备注信息" style="margin-left: -10px;">
								<el-input name="logcont" v-model="form.content" placeholder="请输入备注信息"></el-input>
							</el-form-item>
							<div class="logist_btn">
								<el-button type="primary" @click="onSubmit">确定</el-button>
								<el-button class="logist_qx" @click="cancel">取消</el-button>
								<div id="orderId" orderId=""></div>
							</div>
						</el-form>
					</div>
					<div class="black"></div>
				</div>
				<!--发票信息 -->
				<div class="invoiceBox">
					<div class="invoice">
						<span class="logtit">发票信息</span>
						<el-form ref="invoice" :model="invoice" label-width="100px">
							<!-- <div class="peo">
								<el-form-item label="个人名称" style="margin-left: -10px;">
									<el-input v-model="invoice.invoice_title"></el-input>
								</el-form-item>
							</div> -->
							<div class="comm" style="display: block;">
								<el-form-item label="发票类型" style="margin-left: -10px;">
									<el-input v-model="invoice.typea"></el-input>
								</el-form-item>
								<el-form-item label="个人/单位名称" style="margin-left: -10px;">
									<el-input v-model="invoice.invoice_title"></el-input>
								</el-form-item>
								<el-form-item label="纳税人识别号" style="margin-left: -10px;">
									<el-input v-model="invoice.invoice_no" placeholder="纳税人识别号 企业必填~"></el-input>
								</el-form-item>
								<el-form-item label="注册地址" style="margin-left: -10px;">
									<el-input v-model="invoice.register_address" placeholder="注册地址 企业必填~"></el-input>
								</el-form-item>
								<el-form-item label="注册电话" style="margin-left: -10px;">
									<el-input v-model="invoice.register_phone" placeholder="注册电话 企业必填~"></el-input>
								</el-form-item>
								<el-form-item label="开户银行" style="margin-left: -10px;">
									<el-input v-model="invoice.bank_name" placeholder="开户银行 企业必填~"></el-input>
								</el-form-item>
								<el-form-item label="银行账户" style="margin-left: -10px;">
									<el-input v-model="invoice.bank_code" placeholder="银行账户 企业必填~"></el-input>
								</el-form-item>
							</div>
							<div class="invoice_btn">
								<el-button type="primary" @click="invSubmit">关闭</el-button>
							</div>
						</el-form>
				
					</div>
					<div class="black"></div>
				</div>
			</div>
			<div class="footer">
				<el-pagination style="text-align: center;height: 80px;line-height: 80px;margin: 40px auto;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:page-sizes="[10, 20, 30,50]" :page-size="pageSize" layout="total,  prev, pager, next, jumper"
					:total="total" background>
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import $ from 'jquery'
	import {
		formatDate
	} from '@/assets/js/formatDate.js'
	export default {
		data() {
			return {
				total: 1, //数据总数
				pageSize: 50, //每页显示数量
				currentPage:1,
				imgSrc: 'this.src="' + require('../../assets/img/mr.jpg') + '"',
				p: 1,
				getExpressList: [],
				tableData: [],
				expressList: [],
				deliverVisible: false,
				deliver: {
					express_id: '',
					express_code: '',
					id: ''
				},
				form: {
					getExpressList: [],
				},
				buyer: {
					name: '',
					phone: '',
					youbian: '',
					address: ''
				},
				express_id: '',
				getExpressList: [],
				options: [],
				form: {
					getExpressList: [],
					code: '',
					content: '',
				},
				invoice: {
					typea: '',
					invoice_title: '',
					invoice_no: '',
					register_address: '',
					register_phone: '',
					bank_name: '',
					bank_code: '',
				},
				data: [],
				rules: {
					code: {
						required: true,
						message: '请填写快递单号'
					}
				},
				picUrl:'',
				rootUrl:'',
				user_id:''
			}
		},
		created() {
			this.user_id= this.$store.state.USER_ID
			this.picUrl = this.$store.state.IMG_URL
			this.rootUrl = this.$store.state.ROOT_URL
			this.loadData()
			
		},
		methods: {
			loadData(){
				this.$axios.post('Myseller-SellerManage-orderList',{
					user_id:this.$store.state.USER_ID,
					p:this.currentPage,//默认第一页 
				}).then(data => {
					// this.total = Number(data.count)
					this.tableData = data.list;
					// document.body.scrollTop = document.documentElement.scrollTop = 0
					this.total = Number(data.count)
				})
			},
			handleSizeChange(val) {
				this.pageSize = val
			},
			handleCurrentChange(val){//用户改变当前页的回调函数
				this.currentPage=val
				this.loadData()
			},
			toDeliver(id) {
				$("#orderId").attr("orderId", id)
				$(".logisticsBox").show()
				this.$axios.post('Myseller-Order-getExpressList').then(data => {
					this.getExpressList = data
				})
			},
			open(url) {
				window.open(url);
			},
			fpnews(id) {
				$(".invoiceBox").show()
				this.$axios.post('Myseller-Order-getInvoiceInfo', {
					id: id
				}).then(data => {
					this.invoice = data
					if (data.register_address && data.bank_code && data.bank_name && data.register_phone) {
						this.invoice.typea = "增值税专用发票"
					} else {
						this.invoice.typea = "普通发票"
					}

				})
			},
			changew(value) {
				$(".avatar").attr("express_id", value)
			},
			invSubmit() {
				$(".invoiceBox").hide()
			},
			onSubmit() {
				let order_id = $("#orderId").attr("orderId")
				let express_id = $(".avatar").attr("express_id")
				this.$axios.post('Myseller-Order-doDeliverGoods', {
					user_id:this.$store.state.USER_ID,
					order_id: order_id,
					express_id: express_id,
					express_code: $("input[name=logcode]").val(),
					content: $("input[name=logcont]").val()
				}).then(data => {
					this.$message.success(data.msg)
					if (data.code == 200) {
						$(".avatar").attr("express_id", "")
						$(".logisticsBox").hide()
						location.reload();
					}
				}).catch(data => {
					this.$message.error(data.msg)
				});

			},
			cancel() {
				$(".logisticsBox").hide()
			},
			formatDate(row) {
				let time = row.add_time * 1000
				let date = new Date(time)
				return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
			},
			// toDeliver(row) {
			// 	this.$axios.post('Myseller-Order-deliver_goods', {
			// 		user_id: this.$store.state.USER_ID,
			// 		order_id: row.order_id
			// 	}).then(data => {
			// 		this.expressList = data.express;
			// 		this.buyer.name = data.info.name
			// 		this.buyer.phone = data.info.phone
			// 		this.buyer.youbian = data.info.youbian
			// 		this.buyer.address = data.info.sheng + data.info.shi + data.info.xian
			// 		this.deliver.id = row.order_id
			// 		this.deliverVisible = true
			// 	})
			// },
			deliverSubmit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.$axios.post('Myseller-Order-doDeliverGoods', {
							id: this.deliver.id,
							express_id: this.deliver.express_id,
							express_code: this.deliver.express_code,
							user_id: this.$store.state.USER_ID
						}).then(data => {
							this.getData()
							this.deliverVisible = false
							this.$message({
								message: '发货成功',
								type: 'success'
							});
						})
					} else {
						return false;
					}
				});
			},
			changePrice(row) {
				this.$prompt('只可以修改一次,请慎重', '改价', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^[1-9]{1}[0-9]*$|^0{1}\.{1}[0-9]+$|^[1-9]{1}[0-9]*\.{1}[0-9]+$/,
					inputErrorMessage: '价格必须大于0'
				}).then(({
					value
				}) => {
					this.$axios.post('Myseller-Order-setorderprice', {
						id: row,
						revised_price: value,
						user_id: this.$store.state.USER_ID
					}).then(data => {
						this.getData()
						this.$message({
							type: 'success',
							message: '修改成功'
						});

					})
				}).catch(() => {});
			}
		}
	}
</script>
<style scoped>
	.title_left {}

	.title_left span {
		margin-right: 10px;
	}

	.title_center {}

	.title_center span {
		margin-right: 10px;
	}

	.content {
		font-size: 14px;
	}

	.cont_box {
		margin-top: 20px;
	}

	.bigBox_title {
		height: 60px;
		border-bottom: 1px solid #ccc;
		display: flex;
		justify-content: space-between;
	}

	.lititleBox {}

	.lit_box {
		border: 1px solid #ccc;
		margin-top: 20px;
	}

	.lit_left {
		width: 65%;
		min-width: 660px;
		/* display: flex;
		align-items: center;
		justify-content: space-around; */
		border-right: 1px solid #ccc;
	}

	.box_box {
		display: flex;
		align-items: center;
		justify-content: space-around;
		padding: 20px 0;
		border-bottom: 1px solid #ccc;
	}

	.box_box:nth-last-child(1) {
		border-bottom: 1px solid transparent;
	}

	.lit_title {
		height: 60px;
		border: 1px solid yellowgreen;
		display: flex;
		justify-content: space-between;
	}

	.lit_cont {
		display: flex;
		justify-content: space-around;
	}

	.cont_img {
		width: 100px;
		height: 100px;
		border: 1px solid #ccc;
	}

	.cont_img img {
		width: 100px;
		height: 100px;
	}

	.cont_detail {
		text-align: center;
		min-width: 240px;
		width: 150px;
	}

	.cont_price {
		width: 150px;
		min-width: 150px;
		text-align: center;
	}

	.lit_right {
		width: 35%;
		min-width: 400px;
		display: flex;
		align-items: flex-start;
		justify-content: space-around;
	}

	.lit_store {
		width: 33.3%;
		text-align: center;
		border-right: 1px solid #ccc;
		min-width: 150px;
		text-align: center;
	}

	.lit_detail {
		width: 33.3%;
		text-align: center;
		min-width: 150px;
	}

	.lit_logistics {
		width: 33.3%;
		min-width: 150px;
		text-align: center;
		border-right: 1px solid #ccc;
	}

	.bz {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	.title_box {
		padding: 0 20px;
		display: flex;
		justify-content: space-around;
		height: 40px;
		line-height: 40px;
		background-color: #f5f5f5;
		border-bottom: 1px solid transparent;
	}

	.litcont_box {
		display: flex;
		align-items: center;
		padding: 30px;
		border-top: 1px solid transparent;
	}

	/* 发货 */
	.logistics {
		width: 500px;
		height: 307px;
		position: fixed;
		margin: auto;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		background-color: #fff;
		padding: 25px 30px;
		border-radius: 8px;
		box-shadow: 3px 3px 10px #ccc;
		z-index: 1000;
	}

	.invoice {
		width: 500px;
		height: 546px;
		/* position: absolute; */
		position: fixed;
		margin: auto;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		background-color: #fff;
		padding: 20px 30px;
		border-radius: 8px;
		box-shadow: 3px 3px 10px #ccc;
		z-index: 1000;
	}


	.logist_btn,
	.invoice_btn {
		/* display: flex;
		justify-content: space-around; */
		text-align: center;
	}

	.logtit {
		display: block;
		height: 40px;
		line-height: 40px;
		font-size: 18px;
	}

	.black {
		position: fixed;
		width: 100%;
		height: 100%;
		margin: auto;
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		background-color: rgba(0, 0, 0, 0.5);
	}

	.logisticsBox {
		display: none;
	}

	.invoiceBox {
		display: none;
	}
	.message{
		width:200px;
		line-height: 40px;
		overflow:hidden; 
		text-overflow:ellipsis;
		display:-webkit-box; 
		-webkit-box-orient:vertical;
		-webkit-line-clamp:2; 
	}
	.liuy{
		color: #0077AA;
		font-size: 16px;
		line-height: 30px;
		padding-left: 10px;
	}
	.nullImg{
		width:600px;
		height:600px;
		position: absolute;
		left: 0;right: 0;
		top: 0;bottom: 0;
		margin: auto;
		text-align:center;
	}
	
	/* .nullImg img{
		position: absolute;
		left: 0;right: 0;
		top: 0;bottom: 0;
		margin: auto;
	} */
	.Bigbox{
		/* border: 1px solid red; */
	}
	.el-page-header{
		background-color: #fff !important;
	}
</style>
